/* eslint-disable react/prop-types */
import React from "react";
import DatePicker from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import { Box, Typography } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SwitchBox from "components/SwitchBox";
import SoftTypography from "components/SoftTypography";

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const ModalContent = ({ list, pickAll, setPickAll, handleChangeSwitch }) => {
  const [taxPeriod, setTaxPeriod] = React.useState("month"); // | time
  const [taxType, setTaxType] = React.useState("year"); // | additional

  return (
    <>
      <Box
        sx={{
          p: 1,
          border: "1px solid black",
          borderRadius: 1,
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Chọn kỳ tính thuế
        </Typography>
        <SoftBox display="flex" flexDirection="column" my={1}>
          <SoftTypography component="label" variant="caption" fontWeight="bold" mb={0.5}>
            CQT cấp cục
          </SoftTypography>
          <select style={selectStyle}>
            <option value="1">HCM - Cục thuế Thành phố Hồ Chí Minh</option>
            <option value="2">Tổ chức lại doanh nghiệp</option>
          </select>
        </SoftBox>
        <SoftBox display="flex" flexDirection="column" my={1}>
          <SoftTypography component="label" variant="caption" fontWeight="bold" mb={0.5}>
            CQT nơi nộp
          </SoftTypography>
          <select style={selectStyle}>
            <option value="1">Cục thuế Thành phố Hồ Chí Minh</option>
            <option value="2">Tổ chức lại doanh nghiệp</option>
          </select>
        </SoftBox>

        <SwitchBox
          checked={taxType === "year"}
          onChange={(e) => {
            if (taxType === "year") return;
            if (e.target.checked) setTaxType("year");
          }}
          sx={{ mt: 2 }}
          label="Tờ khai năm"
        />
        <SwitchBox
          checked={taxType === "payment"}
          onChange={(e) => {
            if (taxType === "payment") return;
            if (e.target.checked) setTaxType("payment");
          }}
          label="Tờ khai theo kỳ thanh toán"
        />
        <SwitchBox
          checked={taxType === "month"}
          onChange={(e) => {
            if (taxType === "month") return;
            if (e.target.checked) setTaxType("month");
          }}
          label="Tờ khai tháng"
        />
        <SwitchBox
          checked={taxType === "quarterly"}
          onChange={(e) => {
            if (taxType === "quarterly") return;
            if (e.target.checked) setTaxType("quarterly");
          }}
          label="Tờ khai quý"
        />
        {taxType === "year" && (
          <Box>
            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Năm
              </SoftTypography>
            </SoftBox>
            <SoftInput name="year" type="number" />
          </Box>
        )}
        {taxType === "payment" && (
          <Box display="flex" gap={1}>
            <Box>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Từ ngày
                </SoftTypography>
              </SoftBox>
              <DatePicker
                options={{
                  locale: Vietnamese,
                  time_24hr: true,
                  dateFormat: "m-Y",
                  plugins: [
                    new monthSelectPlugin({
                      shorthand: true,
                      dateFormat: "m/Y",
                      theme: "light",
                    }),
                  ],
                }}
                render={({ defaultValue }, ref) => (
                  <SoftInput defaultValue={defaultValue} inputRef={ref} />
                )}
              />
            </Box>
            <Box>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Đến ngày
                </SoftTypography>
              </SoftBox>
              <DatePicker
                options={{
                  locale: Vietnamese,
                  time_24hr: true,
                  dateFormat: "m-Y",
                  plugins: [
                    new monthSelectPlugin({
                      shorthand: true,
                      dateFormat: "m/Y",
                      theme: "light",
                    }),
                  ],
                }}
                render={({ defaultValue }, ref) => (
                  <SoftInput defaultValue={defaultValue} inputRef={ref} />
                )}
              />
            </Box>
          </Box>
        )}
        {taxType === "month" && (
          <Box>
            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Tháng / Năm
              </SoftTypography>
            </SoftBox>
            <DatePicker
              options={{
                locale: Vietnamese,
                time_24hr: true,
                dateFormat: "m-Y",
                plugins: [
                  new monthSelectPlugin({
                    shorthand: true,
                    dateFormat: "m/Y",
                    theme: "light",
                  }),
                ],
              }}
              render={({ defaultValue }, ref) => (
                <SoftInput defaultValue={defaultValue} inputRef={ref} />
              )}
            />
          </Box>
        )}
        {taxType === "quarterly" && (
          <>
            <Box
              sx={{
                display: "flex",
                gap: 1,
              }}
            >
              <Box>
                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Quý
                  </SoftTypography>
                </SoftBox>
                <SoftInput name="quarterly" type="number" defaultValue={3} />
              </Box>
              <Box>
                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Năm
                  </SoftTypography>
                </SoftBox>
                <SoftInput name="year" type="number" defaultValue={2023} />
              </Box>
            </Box>
            <Box display="flex" gap={1}>
              <Box>
                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Từ tháng
                  </SoftTypography>
                </SoftBox>
                <DatePicker
                  options={{
                    locale: Vietnamese,
                    time_24hr: true,
                    dateFormat: "m-Y",
                    plugins: [
                      new monthSelectPlugin({
                        shorthand: true,
                        dateFormat: "m/Y",
                        theme: "light",
                      }),
                    ],
                  }}
                  render={({ defaultValue }, ref) => (
                    <SoftInput defaultValue={defaultValue} inputRef={ref} />
                  )}
                />
              </Box>
              <Box>
                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Đến tháng
                  </SoftTypography>
                </SoftBox>
                <DatePicker
                  options={{
                    locale: Vietnamese,
                    time_24hr: true,
                    dateFormat: "m-Y",
                    plugins: [
                      new monthSelectPlugin({
                        shorthand: true,
                        dateFormat: "m/Y",
                        theme: "light",
                      }),
                    ],
                  }}
                  render={({ defaultValue }, ref) => (
                    <SoftInput defaultValue={defaultValue} inputRef={ref} />
                  )}
                />
              </Box>
            </Box>
          </>
        )}
        <Box
          sx={{
            p: 1,
            border: "1px solid black",
            borderRadius: 1,
            mt: 1,
          }}
        >
          <SwitchBox
            checked={pickAll}
            onChange={(e) => setPickAll(e.target.checked)}
            label="Chọn phụ lục kê khai"
          />
          <Box
            sx={{
              mt: 1,
              p: 1,
              maxHeight: 200,
              overflow: "auto",
              borderRadius: 1,
              border: "1px solid black",
            }}
          >
            {list.map((item, index) => (
              <SwitchBox
                key={index}
                name={item.name}
                checked={item.disabled ? false : pickAll ? pickAll : item.checked}
                onChange={(e) => handleChangeSwitch(item.name, e.target.checked)}
                label={item.name}
                disabled={item.disabled}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ModalContent;
